module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/year_bg2-78663d.png";